/**
 * Reload the signed-in user, deciding what a failure means.
 *
 * By default a failed reload ends the session (token cleared, user unset), which
 * is right when a caller needs to know the session is dead. A caller that is only
 * syncing a flag it has just saved, such as the welcome tour, passes
 * `keepSessionOnError` so a transient failure does not sign the person out.
 */
export interface RefreshSessionDeps<U> {
  fetchUser: () => Promise<U>;
  setUser: (user: U | null) => void;
  clearToken: () => void;
}

export async function refreshSession<U>(
  deps: RefreshSessionDeps<U>,
  options: { keepSessionOnError?: boolean } = {},
): Promise<void> {
  try {
    deps.setUser(await deps.fetchUser());
  } catch (error: unknown) {
    if (!options.keepSessionOnError) {
      deps.clearToken();
      deps.setUser(null);
    }
    throw error;
  }
}
